import React from "react";

import { Link } from "react-router-dom";
export default function About() {
  return (
    <>
     
      <section className="layout-pt-sm layout-pb-lg bg-white">
        <div className="container">
          <div className="row y-gap-50 text-dark-1 justify-between items-center">
            {/* <div className="col-lg-6 pr-50 sm:pr-15">
              <div className="composition -type-8">
                <div className="-el-1">
                  <img src="/assets/img/about-1/1.png" alt="image" />
                </div>
                <div className="-el-2">
                  <img src="/assets/img/about-1/2.png" alt="image" />
                </div>
                <div className="-el-3">
                  <img src="/assets/img/about-1/3.png" alt="image" />
                </div>
              </div>
            </div> */}

            <div className="col-lg-12">
              <h2 className="text-30 lh-16">Welcome to GVKEdu!.</h2>
              <p className=" mt-30">
                GVK EDU, formerly known as Mithra Academy, has been a pioneer in
                pharmacy education, dedicated to providing top-notch coaching
                and study materials for pharmacy competitive exams. Since taking
                over Mithra Academy in 2014, we have trained thousands of
                students for prestigious entrance exams like GPAT, NIPER, and
                PGCET, securing hundreds of GPAT and NIPER ranks.
              </p>
              <p className="pr-50 text-dark-1 lg:pr-0 mt-25">
                We expanded our services to 100% online coaching in 2021
                post-COVID, making high-quality education accessible to pharmacy
                aspirants across India. Our online platform offers structured
                courses for TSPSC Pharmacist Grade 2, TSPSC Drug Inspector,
                ESIC, RRB, CRE, AIIMS, CGHS, ARMY, and more. GVK EDU takes
                immense pride in our students’ achievements, including:
                <br></br>
                <ul>
                  <li>
                    🏆 TSPSC Drug Inspector State 1st Rank – Bejjrapu Mounika
                  </li>
                  <li>🏆 ESIC State 1st Rank – B. Mounika</li>{" "}
                  <li> 🏆 TSPSC State 25th Rank – B. Mounika</li>
                  <li> 🏆 DI State 13th Rank – S. Ravali </li>{" "}
                  <li>🏆 DI State 14th Rank – S. Vinay</li>
                </ul>
              </p>
              <p className="mt-25">
                We have successfully launched two comprehensive books:
                <li>
                  📖 TSPSC Pharmacist Grade 2 Study Material – A syllabus-wise
                  guide for TSPSC pharmacist exams.
                </li>
                <li> 📖 RRB Pharmacist Syllabus-Wise Running Notes</li> – Our
                latest book covering 100% syllabus with running notes, MCQs with
                justifications, and previous year solved papers. Additionally,
                we offer Book-Based Online Coaching, where students can
                selectively pay for the topics they need, making quality
                education more affordable and accessible.
              </p>
              <div className="d-inline-block">
                <Link
                  to="/login"
                  className="button -md -black text-white mt-30"
                >
                  Start Learning
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
